import React from "react";
import { withRouter } from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  Button,
  MenuItem,
  TextField,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
import Layout from "../layouts/Layout";
import WarningIcon from "@material-ui/icons/Warning";
import Moment from "moment";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { primaryShade1, grey, white, black } from "../styles/color";
import AddNewDialog from "../components/AddNewDialog";
const variantIcon = {
  warning: WarningIcon
};

const stylesSnackbar = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(stylesSnackbar)(MySnackbarContent);

const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
class AddDispatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      transporterName: [],
      currentTransporterName: "NONE",
      vehicleNumber: "",
      quantity: 0,
      paidDispatch: 0,
      pendingDispatch: 0,
      charges: 0,
      description: "",
      openSnackBar: false,
      remainingQuantity: 0,
      organisationId: "",
      dialogFor: null,
      entryName: ""
    };
    if (window.cordova) {
      this.image = `${window.cordova.file.applicationDirectory}www`;
    }
  }
  componentWillMount = () => {
    this.initializeData(this.props);
  };
  componentWillReceiveProps = nextProps => {
    this.initializeData(nextProps);
  };
  initializeData = whichProps => {
    const singleDeal =
      whichProps.deals && whichProps.deals.length > 0
        ? whichProps.deals.find(ele => {
            return ele.id === this.props.match.params.dealId;
          })
        : null;
    if (!singleDeal) {
      this.setState({ singleDeal, remainingQuantity: 0 }, () => {
        console.log(1);
      });
    } else {
      this.setState(
        { singleDeal, remainingQuantity: singleDeal.pendingDelivered },
        () => {
          console.log(1);
        }
      );
    }
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
    if (whichProps.transporters && whichProps.transporters.length > 0) {
      this.setState({ transporters: whichProps.transporters }, () => {
        console.log(1);
      });
    }
  };
  handleChange = name => event => {
    if (event.target.value === "addTransporter") {
      this.handleAddNewDialog(event.target.value);
    } else {
      this.setState({ [name]: event.target.value });
    }
  };
  handleAddNewDialog = dialogFor => {
    this.setState({ openAddNewDialog: true, dialogFor });
  };
  handleCloseAddNewDialog = () => {
    this.setState({
      openAddNewDialog: false,
      dialogFor: null,
      entryName: null
    });
  };
  handleCreateDialogEntrySelection = (entryData, dialogFor) => {
    this.props.handleCreateDialogEntry(entryData, dialogFor).then(doc => {
      if (dialogFor === "addTransporter") {
        let currentTransporterName = this.props.transporters.find(
          o => o.id === doc.id
        ).transporterName;
        this.setState({ currentTransporterName }, () => {
          console.log(1);
        });
      }
    });
    this.handleCloseAddNewDialog();
  };
  handleDateChange = name => event => {
    this.setState({ [name]: new Date(event.target.value) });
  };
  handleDispatchChange = name => event => {
    this.setState({ [name]: event.target.value });
    this.calculateDispatch(event.target.value);
  };
  calculateDispatch = amount => {
    var singleDeal = this.props.deals.find(ele => {
      return ele.id === this.props.match.params.dealId;
    });
    let pendingDelivered = singleDeal.pendingDelivered - parseInt(amount, 10);
    let paidDelivered = singleDeal.paidDelivered + parseInt(amount, 10);
    this.setState({ pendingDelivered, paidDelivered });
  };
  handleOpenSnackBar = () => {
    this.setState({ openSnackBar: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };
  render() {
    const { addDealDispatch, classes, user } = this.props;
    const {
      currentTransporterName,
      date,
      pendingDelivered,
      paidDelivered,
      vehicleNumber,
      remainingQuantity,
      organisationId,
      entryName,
      dialogFor,
      openAddNewDialog,
      transporters
    } = this.state;
    return (
      <Layout
        position="static"
        appBar
        appBarTitle={"ADD DISPATCH"}
        appBarLeftIcon={true}
      >
        <div
          style={{
            top: "66px",
            position: "absolute",
            width: "100vw",
            height: "calc(100vh - 66px)",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100vh - 122px)",
              overflowY: "scroll"
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <img
                src={
                  window.cordova
                    ? `${this.image}${"/dispatch.png"}`
                    : "/dispatch.png"
                }
                alt=""
                height="150px"
              />
            </div>
            <TextField
              id="outlined-bare"
              type="date"
              defaultValue={Moment(date).format("YYYY-MM-DD")}
              label="Date"
              name="date"
              required={true}
              onChange={this.handleDateChange("date")}
              className={classNames(classes.margin)}
              InputLabelProps={{
                shrink: true
              }}
              margin="normal"
              variant="outlined"
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
              <TextField
                style={{ flex: 3 }}
                required
                id="outlined-required"
                label="Quantity"
                placeholder={"Remaining: " + remainingQuantity}
                type="number"
                onChange={this.handleDispatchChange("quantity")}
                className={classNames(classes.margin)}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">ton</InputAdornment>
                  )
                }}
                margin="normal"
                variant="outlined"
              />
              <TextField
                style={{ flex: 2 }}
                required
                id="outlined-required"
                label="CHARGES"
                type="number"
                onChange={this.handleChange("charges")}
                className={classNames(classes.margin)}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₹</InputAdornment>
                  )
                }}
                margin="normal"
                variant="outlined"
              />
            </div>

            <div style={{ display: "flex", flexDirection: "row" }}>
              <TextField
                select
                style={{ flex: 3 }}
                className={classNames(classes.margin)}
                variant="outlined"
                label="Select Transporter"
                value={currentTransporterName}
                required={true}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange("currentTransporterName")}
              >
                <MenuItem style={{ color: grey }} value="NONE">
                  None
                </MenuItem>
                {transporters && transporters.length > 0
                  ? transporters.map(data => (
                      <MenuItem
                        value={data.transporterName}
                        style={{ color: black }}
                      >
                        {data.transporterName}
                      </MenuItem>
                    ))
                  : ""}
                <MenuItem style={{ color: "grey" }} value="addTransporter">
                  Add
                </MenuItem>
              </TextField>

              <TextField
                id="outlined-bare"
                placeholder="CG04XY1234"
                style={{ flex: 3 }}
                label="Vehicle Number"
                onChange={this.handleChange("vehicleNumber")}
                value={vehicleNumber}
                required={true}
                InputLabelProps={{
                  shrink: true
                }}
                className={classNames(classes.margin)}
                variant="outlined"
              />
            </div>

            <TextField
              name="description"
              label="Description"
              multiline
              rows="4"
              rowsMax="4"
              onChange={this.handleChange("currentDescription")}
              className={classNames(classes.margin)}
              InputLabelProps={{
                shrink: true
              }}
              variant="outlined"
            />

            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              open={this.state.openSnackBar}
              autoHideDuration={3000}
              onClose={this.handleClose}
            >
              <MySnackbarContentWrapper
                variant="warning"
                message="Please fill fields marked with * before adding deal dispatch...!"
              />
            </Snackbar>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "56px",
              position: "absolute",
              bottom: "0px",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Button
              onClick={e => {
                e.preventDefault();
                if (
                  this.state.quantity &&
                  this.state.currentTransporterName &&
                  this.state.vehicleNumber &&
                  this.state.date !== ""
                ) {
                  const dispatch = {
                    quantity: this.state.quantity,
                    transporter: this.state.currentTransporterName,
                    vehicleNumber: this.state.vehicleNumber,
                    date: this.state.date,
                    dealId: this.props.match.params.dealId,
                    charges: this.state.charges,
                    description: this.state.description,
                    organisationId: organisationId,
                    createdAt: new Date()
                  };
                  console.log(dispatch);
                  addDealDispatch(dispatch);
                  this.props.updateSingleDealDispatchHistory(
                    this.props.match.params.dealId,
                    pendingDelivered,
                    paidDelivered
                  );
                  this.props.history.goBack();
                } else {
                  this.handleOpenSnackBar();
                }
              }}
              variant="contained"
              style={{
                backgroundColor: primaryShade1,
                color: "white",
                width: "100%",
                height: "100%"
              }}
            >
              Add Dispatch
            </Button>
            <AddNewDialog
              dialogOpen={openAddNewDialog}
              dialogClose={this.handleCloseAddNewDialog}
              dialogFor={dialogFor}
              entryName={entryName}
              handleChange={this.handleChange}
              user={user}
              handleCreateDialogEntry={this.handleCreateDialogEntrySelection}
              organisationId={organisationId}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

export default withRouter(withStyles(stylesMain)(AddDispatch));
